import React from "react";
import BlueHeading from "../other/common/BlueHeading";
import { ABOUT_BOOK_LIST } from "../../utils/other-component";
import Icons from "../common/components/Icons";
import aboutBookImg from "../../assets/images/webp/other/about-book-img.webp";
import rightLeafImg from "../../assets/images/webp/other/right-leaf-img.webp";

const AboutBook = () => {
  return (
    <>
      <div className="relative px-4 pt-[140px] max-xl:pt-[120px] max-lg:pt-26 max-md:pt-20 max-sm:pt-10">
        <img
          src={rightLeafImg}
          alt="leaf"
          width={86}
          height={179}
          className="w-full max-w-[86px] pointer-events-none top-0 right-0 absolute object-contain"
        />
        <div className="max-w-[982px] mx-auto flex gap-[66px] flex-wrap-reverse max-lg:gap-12 max-md:gap-10 max-sm:gap-6">
          <img
            src={aboutBookImg}
            alt="about"
            width={484}
            height={358}
            className="w-full max-w-[484px] pointer-events-none"
          />
          <div className="relative z-10">
            <BlueHeading lineClassOne="!hidden" text="About the book" />
            <h2 className="font-bold ff-jakarta text-[50px] max-xl:text-5xl max-lg:text-4xl max-md:text-3xl leading-[120%] max-w-[432px] text-[#001A3D]">
              This Isn’t Just a Book. It’s a Mind-Reset Manual
            </h2>
            {ABOUT_BOOK_LIST.map((item, index) => (
              <div className="flex items-center gap-1 pt-4" key={index}>
                <Icons icon="CheckIcon" />
                <p className="text-[#001A3D] font-semibold text-sm leading-[19.31px]">
                  {item}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutBook;
